import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { stroke: true },
  },
});

type MinusProps = SvgProps & {
  className?: string;
  pathClassName?: string;
};

function MinusIcon({
  className,
  pathClassName = "stroke-textPrimary",
  ...props
}: MinusProps) {
  return (
    <Svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      className={className}
      fill="none"
      {...props}
    >
      <Path
        d="M19.5 12h-15"
        stroke="#000"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={pathClassName}
      />
    </Svg>
  );
}

export default MinusIcon;
